module.exports = __webpack_public_path__ + "static/img/luntai.1c1b3111.svg";